import { render, staticRenderFns } from "./EditCollectionGroup.vue?vue&type=template&id=cdea10da"
import script from "./EditCollectionGroup.vue?vue&type=script&lang=js"
export * from "./EditCollectionGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports